module.exports = __webpack_public_path__ + "img/flow.91a4d4e2.png";